import React, { useState, useEffect, Fragment } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { faSuitcaseRolling } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Row } from 'reactstrap';
import Cell from './components/Cell';
import RateCell from './components/RateCell';
import Legend from './Legend';
import {
  TableSytle,
  HorizontalContainer,
  VerticalContainer,
  CellHeader,
  CellHeader2,
} from './Layout';
import InventoryEditModal from './components/InventoryEditModal';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { AxiosAPI } from '../../../../helpers/AxiosAPI';
import { gAPI_Ari_Room } from '../../../../constants/APIs';
import { gAPI_LinkedRoomList_ByPropertyId } from '../../../../constants/APIs';
import RestrictionsEditModal from './components/RestrictionsEditModal';
import RatesEditModal from './components/RatesEditModal';

const Room = ({ roomData, isEditingInventoryCell, currency }) => {
  const [display, setDisplay] = useState(true);
  const [style, setStyle] = useState({});

  useEffect(() => {
    if (display) {
      setStyle({
        display: 'flex',
      });
    } else {
      setStyle({
        display: 'none',
      });
    }
  }, [display]);
  return (
    <Fragment>
      <h1
        style={{
          display: 'block',
          marginTop: '15px',
        }}
      >
        <div
          style={{
            fontSize: '15px',
            cursor: 'pointer',
            display: 'inline-block',
          }}
        >
          {display ? <span>▼ </span> : <span>▶ </span>}
          <span
            onClick={() => setDisplay(!display)}
            style={{
              fontSize: '22px',
            }}
          >
            {roomData.roomName}
          </span>
        </div>
      </h1>

      <HorizontalContainer style={style}>
        <VerticalContainer>
          <CellHeader>
            <FontAwesomeIcon
              icon={faSuitcaseRolling}
              style={{
                fontSize: '14px',
                marginBottom: '1px',
                marginRight: '10px',
              }}
            />
            {roomData.ratePlanName}
          </CellHeader>
          <CellHeader2>Availability</CellHeader2>
          <CellHeader2>Rate ({currency})</CellHeader2>
        </VerticalContainer>
        {roomData.data &&
          roomData.data.map((elem, index) => {
            return (
              <div className="ctns-xs" key={index}>
                <Cell text="-" disabled={true} />
                <Cell
                  // cell's text will be the available num of rooms
                  roomTypeId={roomData.roomTypeId}
                  text={elem.inventory}
                  rate={elem.rate}
                  date={elem.date}
                  stopsell={elem.stopSell}
                  cta={elem.closedToArrival}
                  ctd={elem.closedToDeparture}
                  isEditingInventoryCell={isEditingInventoryCell}
                />
                <RateCell
                  // cell's text will be the room's price
                  roomTypeId={roomData.roomTypeId}
                  ratePlanId={roomData.ratePlanId}
                  text={elem.rate}
                  rate={elem.rate}
                  date={elem.date}
                  stopsell={elem.stopSell}
                  cta={elem.closedToArrival}
                  ctd={elem.closedToDeparture}
                  isEditingInventoryCell={isEditingInventoryCell}
                  currency={elem.currency}
                  includeTax={elem.taxIncluded}
                  numberOfGuests={elem.guestCount}
                />
              </div>
            );
          })}
      </HorizontalContainer>
    </Fragment>
  );
};

const AriRoomsTable = ({ propertyId, startDate, endDate, currency }) => {
  const [roomDate, setRoomDate] = useState([]);
  /** Edit inventory & Edit bulk inventory */
  const [isEditingInventoryCell, setIsEditingInventoryCell] = useState(false);

  const [isEditingBulkInventory, setIsEditingBulkInventory] = useState(false);
  /** Edit bulk restrictions */
  const [isEditingBulkRestriction, setIsEditingBulkRestriction] = useState(
    false
  );
  const [isEditingBulkRates, setIsEditingBulkRates] = useState(
    false
  );

  const [roomlist, setRoomlist] = useState([]);
  const [ratelist, setRatelist] = useState([]);

  useEffect(() => {
    AxiosAPI({
      methed: 'get',
      url: `${gAPI_Ari_Room}?propertyId=${propertyId}&fromDate=${startDate}&toDate=${endDate}`,
    })
      .then(res => {
        if (res.data.length === 0) {
          setRoomDate([]);
        } else {
          setRoomDate(res.data);
          //console.log('res.data', res.data);
          // const roomlist = res.data.map(elem => ({
          //   roomTypeId: elem.roomTypeId,
          //   roomName: elem.roomName,
          // }));
          // const ratelist = res.data.map(elem => ({
          //   ratePlanId: elem.ratePlanId,
          //   ratePlanName: elem.ratePlanName,
          // }));
          // setRoomlist(roomlist);
          // setRatelist(ratelist);
        }
      })
      .catch(err => {
        console.log(err);
      });

    AxiosAPI({
      methed: 'get',
      url: `${gAPI_LinkedRoomList_ByPropertyId}?propertyId=${propertyId}`,
    })
      .then(res => {
        if (res.data.length === 0) {
          setRoomlist([]);
        } else {
          //console.log('res.data', res.data);
          const roomlist = res.data.map(elem => ({
            roomTypeId: elem.id,
            roomName: elem.name,
          }));
          setRoomlist(roomlist);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, [propertyId, startDate, endDate]);

  return (
    <div>
      <TableSytle>
        {roomDate.map((data, index) => (
          <Room
            roomData={data}
            isEditingInventoryCell={isEditingInventoryCell}
            key={index}
            currency={currency}
          />
        ))}
      </TableSytle>
      <Legend />
      <InventoryEditModal
        toggleModal={() => {
          setIsEditingBulkInventory(!isEditingBulkInventory);
        }}
        isVisible={isEditingBulkInventory}
        roomlist={roomlist}
      />
      <RestrictionsEditModal
        toggleModal={() => {
          setIsEditingBulkRestriction(!isEditingBulkRestriction);
        }}
        isVisible={isEditingBulkRestriction}
        roomlist={roomlist}
        ratelist={ratelist}
      />
      <RatesEditModal
        toggleModal={() => {
          setIsEditingBulkRates(!isEditingBulkRates);
        }}
        isVisible={isEditingBulkRates}
        roomlist={roomlist}
        ratelist={ratelist}
      />
      <Row style={{ marginTop: '30px' }}>
        {isEditingInventoryCell ? (
          <Button
            color="success"
            outline
            size="sm"
            onClick={() => {
              setTimeout(() => {
                window.location.reload();
              }, 300);
            }}
          >
            Confirm All
          </Button>
        ) : (
            <Button
              color="primary"
              outline
              size="sm"
              onClick={() => setIsEditingInventoryCell(!isEditingInventoryCell)}
            >
              Edit Inventory and Rate
            </Button>
          )}
        <Button
          color="primary"
          outline
          size="sm"
          onClick={() => setIsEditingBulkInventory(!isEditingBulkInventory)}
        >
          Bulk Edit Inventory
        </Button>
        <Button
          color="primary"
          outline
          size="sm"
          onClick={() => setIsEditingBulkRates(!isEditingBulkRates)}
        >
          Bulk Edit Rate
        </Button>
        <Button
          color="secondary"
          outline
          size="sm"
          onClick={() => setIsEditingBulkRestriction(!isEditingBulkRestriction)}
        >
          Bulk Edit Restriction
        </Button>
      </Row>
    </div>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, currency } = settings;
  return {
    propertyId,
    currency
  };
};

export default injectIntl(connect(mapStateToProps, {})(AriRoomsTable));
